import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIndeedComponent } from './simple-icons-indeed.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIndeedComponent ],
    exports:      [ SimpleIconsIndeedComponent ],
    bootstrap:    []
})
export class SimpleIconsIndeedModule {}
